import { useCallback, useEffect, useMemo, useState } from "react";
import { FaFilter } from "react-icons/fa";
import Modal from "./Modal";
import Pagination from "./Pagination";
import "jspdf-autotable";
import { useSelector } from "react-redux";
import { getOrganisation, getUser, payoutData } from "../../../config/LiveApi";
import { MdContentCopy } from "react-icons/md";
import { toast } from "react-toastify";
import Select from "react-select";
import "./Report.css";
import Spinner from "../../Spin/Spinner";

function ReportTable({
  currentItems,
  setCurrentItems,
  tableData,
  page,
  setPage, 
  totalPages,
  startDate,
  endDate,
  isSearching,
}) {
  const [showStatus, setShowStatus] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [orgName, setOrgName] = useState(false);
  const [orgOptions, setOrgOptions] = useState([]);
  const [selectedOrgName, setSelectedOrgName] = useState("All");
  const [listofusers, setListofUser] = useState([]);
  const [businessName, setBusinessName] = useState(false);
  const [statusOpen, setStatusOpen] = useState(false);
  const [selectedBusinessName, setSelectedBusinessName] = useState("All");
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [mode, setMode] = useState(false);
  const [selectedMode, setSelectedMode] = useState("All");
  const [loading, setLoading] = useState(false);

  const businessOptions = useMemo(() => {
    if (!Array.isArray(listofusers)) return [];

    return listofusers.map((user) => ({
      value: user.id,
      label: user?.alias || user?.id,
    }));
  }, [listofusers]);

  const orgSelectOptions = useMemo(() => {
    if (!Array.isArray(orgOptions)) return [];

    return orgOptions.map((org) => ({
      value: org.orgName,
      label: org.orgName,
    }));
  }, [orgOptions]);

  const role = useSelector((store) => store.userReducer.role);
  const token = useSelector((store) => store.userReducer.token);
  const viewData = (item, setModalData, setOpenModal) => {
    setModalData(item);
    setOpenModal(true);
  };
  const dataToShow = tableData.length > 0 ? tableData : currentItems;

  useEffect(() => {
    if (isSearching) return;
    const fetchOrganisations = async () => {
      try {
        if (role === "mops" || role === "admin" || role === "subAdmin") return;
        const response = await getOrganisation(token);
        const orgData = response.data;
        setOrgOptions(orgData);
      } catch (err) {
        console.error("Error fetching organisations:", err.message);
      }
    };

    fetchOrganisations();
  }, [token, isSearching, role]);

  const fetchUsers = useCallback(async () => {
    try {
      if (role === "mops" || role === "admin" || role === "subAdmin") return;
      const response = await getUser(token);

      const data = response?.data;
      const adminUsers = data.filter((user) => user.role === "admin");

      setListofUser(adminUsers);
    } catch (error) {
      console.log(error.message);
    }
  }, [token, role]);

  useEffect(() => {
    if (isSearching) return;
    fetchUsers();
  }, [isSearching, fetchUsers]);

  useEffect(() => {
    if (isSearching) return;
    const fetchTransactions = async () => {
      setLoading(true);
      try {
        const response = await payoutData(
          token,
          page,
          startDate,
          endDate,
          selectedOrgName === "All" ? "" : selectedOrgName,
          selectedBusinessName === "All" ? "" : selectedBusinessName,
          selectedStatus === "All" ? "" : selectedStatus,
          selectedMode === "All" ? "" : selectedMode
        );

        setCurrentItems(response);
      } catch (error) {
        console.error("Error fetching transactions:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, [
    selectedOrgName,
    selectedBusinessName,
    selectedStatus,
    selectedMode,
    isSearching,
    startDate,
    endDate,
    page,
    setCurrentItems,
    token,
  ]);
  
  const listofMode = ["IMPS", "UPI"];
  return (
    <>
      <div
        className="table-main-report"
        style={{
          maxHeight: "650px",
          // overflow: "auto",
          position: "sticky",
          padding: "0px 10px 0px 10px",
        }}
      >
        {dataToShow ? (
          dataToShow.length > 0 ? (
            <table
              className="table-user-management"
              style={{
                width: "100%",
                borderCollapse: "collapse",
              }}
            >
              <thead
                className="table-user-report"
                style={{
                  position: "sticky",
                  top: "0",
                  zIndex: "999",
                  height: "45px",
                }}
              >
                <tr>
                  {(role == "super" ||
                    role == "operation" ||
                    role == "trafficManager" ||
                    role == "subSuper") && (
                    <th className="filter-pos">
                      <div className="data-icon">
                        <p className="user-table-head-report">Org Name</p>
                        <FaFilter
                          style={{
                            marginRight: "0.2rem",
                            width: "1rem",
                            height: "1rem",
                            cursor: "pointer",
                          }}
                          onMouseEnter={() => setOrgName(true)}
                          onMouseLeave={() => setOrgName(false)}
                        />
                      </div>
                      {orgName && (
                        <div
                          className="transfer-mode"
                          style={{
                            padding: "4px",
                            minWidth: "200px",
                            width: "max-content",
                            maxWidth: "90vw",
                          }}
                          onMouseEnter={() => setOrgName(true)}
                          onMouseLeave={(e) => {
                            if (e.relatedTarget?.closest?.(".transfer-mode"))
                              return;
                            setOrgName(false);
                          }}
                        >
                          <Select
                            options={[
                              { value: "All", label: "All" },
                              ...(orgSelectOptions?.length
                                ? orgSelectOptions
                                : []),
                            ]}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            placeholder="Search Org..."
                            isClearable
                            // isLoading={isOrgLoading}
                            // noOptionsMessage={() =>
                            //   isOrgLoading ? "Loading..." : "No org found"
                            // }
                            menuPlacement="auto"
                            onChange={(option) => {
                              setSelectedOrgName(option?.value || "All");
                              setOrgName(false);
                            }}
                            styles={{
                              menu: (base) => ({ ...base, zIndex: 9999 }),
                              control: (base) => ({
                                ...base,
                                minHeight: "32px",
                                height: "32px",
                              }),
                              indicatorsContainer: (base) => ({
                                ...base,
                                height: "32px",
                              }),
                            }}
                          />
                        </div>
                      )}
                    </th>
                  )}
                  {(role == "super" ||
                    role == "operation" ||
                    role == "trafficManager" ||
                    role == "subSuper") && (
                    <th className="filter-pos">
                      <div className="data-icon">
                        <p className="user-table-head-report">Business Name</p>
                        <FaFilter
                          style={{
                            marginRight: "0.2rem",
                            width: "1rem",
                            height: "1rem",
                            cursor: "pointer",
                          }}
                          onMouseEnter={() => setBusinessName(true)}
                          onMouseLeave={() => setBusinessName(false)}
                        />
                      </div>
                      {businessName && (
                        <div
                          className="transfer-mode"
                          onMouseEnter={() => setBusinessName(true)}
                          onMouseLeave={(e) => {
                            if (e.relatedTarget?.closest?.(".transfer-mode"))
                              return;
                            setBusinessName(false);
                          }}
                        >
                          <div
                            style={{
                              width: "220px",
                              padding: "0.5rem",
                            }}
                            onMouseEnter={() => setBusinessName(true)}
                            onMouseLeave={(e) => {
                              if (e.relatedTarget?.closest?.(".transfer-mode"))
                                return;
                              setBusinessName(false);
                            }}
                          >
                            <Select
                              options={[
                                { value: "All", label: "All" },
                                ...businessOptions,
                              ]}
                              menuPortalTarget={document.body}
                              menuPosition="fixed"
                              placeholder="Search Business..."
                              isClearable
                              menuPlacement="auto"
                              onChange={(option) => {
                                setSelectedBusinessName(option?.value || "All");
                                setBusinessName(false);
                              }}
                              styles={{
                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                control: (base) => ({
                                  ...base,
                                  minHeight: "32px",
                                  height: "32px",
                                }),
                                indicatorsContainer: (base) => ({
                                  ...base,
                                  height: "32px",
                                }),
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </th>
                  )}
                  {(role == "super" ||
                    role == "operation" ||
                    role == "trafficManager" ||
                    role == "subSuper") && (
                    <td>
                      <p className="user-table-head-report">PG Name</p>
                    </td>
                  )}
                  <td>
                    <p className="user-table-head-report">Order Id</p>
                  </td>
                  <th className="filter-pos">
                    <div className="data-icon">
                      <p className="user-table-head-report">Transfer Mode</p>
                      <FaFilter
                        style={{
                          marginRight: "0.2rem",
                          width: "1rem",
                          height: "1rem",
                          cursor: "pointer",
                        }}
                        onMouseEnter={() => setMode(true)}
                        onMouseLeave={() => setMode(false)}
                      />
                    </div>
                    {mode && (
                      <div
                        className="transfer-mode"
                        onMouseEnter={() => setMode(true)}
                        onMouseLeave={() => setMode(false)}
                      >
                        <p
                          onClick={() => {
                            setSelectedMode("All");
                            setMode(false);
                          }}
                        >
                          All
                        </p>
                        <div
                          style={{
                            maxHeight: "300px",
                            overflowY: "auto",
                            padding: "0.5rem",
                          }}
                        >
                          {listofMode.map((mode) => (
                            <p
                              key={mode.id}
                              onClick={() => {
                                setSelectedMode(mode);
                                setMode(false);
                              }}
                            >
                              {mode}
                            </p>
                          ))}
                        </div>
                      </div>
                    )}
                  </th>
                  <td>
                    <p className="user-table-head-report">Amount (₹)</p>
                  </td>

                  <td>
                    <p className="user-table-head-report">Comm.(₹)</p>
                  </td>
                  <td>
                    <p className="user-table-head-report">Transaction Date</p>
                  </td>
                  <td>
                    <p className="user-table-head-report">Updated Date</p>
                  </td>
                  <th className="filter-pos">
                    <div className="data-icon">
                      <p className="user-table-head-report">Status</p>
                      <FaFilter
                        style={{
                          marginRight: "0.2rem",
                          width: "1rem",
                          height: "1rem",
                          cursor: "pointer",
                        }}
                        onMouseEnter={() => setStatusOpen(true)}
                        onMouseLeave={() => setStatusOpen(false)}
                      />
                    </div>
                    {statusOpen && (
                      <div
                        className="status-mode"
                        onMouseEnter={() => setStatusOpen(true)}
                        onMouseLeave={() => setStatusOpen(false)}
                      >
                        <p
                          onClick={() => {
                            setSelectedStatus("All");
                            setStatusOpen(false);
                          }}
                        >
                          All
                        </p>
                        <p
                          onClick={() => {
                            setSelectedStatus("SETTLED");
                            setStatusOpen(false);
                          }}
                        >
                          Settled
                        </p>
                        <p
                          onClick={() => {
                            setSelectedStatus("SETTLEMENT_PROCESS");
                            setStatusOpen(false);
                          }}
                        >
                          Processing
                        </p>
                        <p
                          onClick={() => {
                            setSelectedStatus("SETTLEMENT_FAILED");
                            setStatusOpen(false);
                          }}
                        >
                          Failed
                        </p>
                      </div>
                    )}
                  </th>
                  <td>
                    <p className="user-table-head-report">Action</p>
                  </td>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="10">
                      <Spinner />
                    </td>
                  </tr>
                ) : (
                  dataToShow &&
                  dataToShow.length > 0 &&
                  dataToShow.map((item, i) => {
                    const dateString = item.createdAt;
                    item.requestData = JSON.parse(item.request);
                    item.responseData = JSON.parse(item.resposne);
                    const date = new Date(dateString);
                    const day = date.getDate();
                    const month = date.getMonth() + 1;
                    const year = date.getFullYear();
                    const hours = date.getHours();
                    const minutes = date.getMinutes();
                    const seconds = date.getSeconds();
                    const formattedDate = `${day}-${month}-${year}`;
                    const formattedTime = `${hours}:${minutes}:${seconds}`;
                    return (
                      <tr key={i} className="user-table-head-report">
                        {(role == "super" ||
                          role == "operation" ||
                          role == "trafficManager" ||
                          role == "subSuper") && (
                          <td>
                            <p className="table-user-data-report order-break">
                              {item.orgName ? item.orgName : "N/A"}
                            </p>
                          </td>
                        )}

                        {(role == "super" ||
                          role == "operation" ||
                          role == "trafficManager" ||
                          role == "subSuper") && (
                          <td>
                            <p
                              className="table-user-data-report order-break"
                              style={{ width: "10rem" }}
                            >
                              {item?.alias || item?.userId}
                            </p>
                          </td>
                        )}
                        {(role == "super" ||
                          role == "operation" ||
                          role == "trafficManager" ||
                          role == "subSuper") && (
                          <td>
                            <p className="table-user-data-report order-break">
                              {item.pg ? item.pg : ""}
                            </p>
                          </td>
                        )}
                        <td>
                          <span
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <p
                              className="table-user-data-report"
                              style={{ wordBreak: "break-all" }}
                            >
                              {item && item.orderId}
                            </p>
                            <MdContentCopy
                              className="copy-icon-payout-report"
                              onClick={() => {
                                navigator.clipboard.writeText(item.orderId);
                                item.orderId &&
                                  toast.success("Copied OrderId to Clipboard");
                              }}
                            />
                          </span>
                        </td>
                        <td>
                          <p className="table-user-data-report">
                            {item?.requestData.mode || "N/A"}
                          </p>
                        </td>
                        <td>
                          <p className="table-user-data-report">
                            {item &&
                              item.requestData &&
                              item.requestData.amount}
                          </p>
                        </td>

                        <td>
                          <p className="table-user-data-report status-table order-break">
                            {item.responseStatus === "SETTLED"
                              ? item.totalComission
                              : 0}
                          </p>
                        </td>

                        <td>
                          <p className="table-user-data-report">
                            {formattedDate} {formattedTime}
                          </p>
                        </td>
                        <td>
                          <p className="table-user-data-report">
                            {(() => {
                              const date = new Date(item.updatedAt);
                              const formattedDate = `${date.getDate()}-${
                                date.getMonth() + 1
                              }-${date.getFullYear()}`;
                              const formattedTime = `${date
                                .getHours()
                                .toString()
                                .padStart(2, "0")}:${date
                                .getMinutes()
                                .toString()
                                .padStart(2, "0")}:${date
                                .getSeconds()
                                .toString()
                                .padStart(2, "0")}`;
                              return `${formattedDate} ${formattedTime}`;
                            })()}
                          </p>
                        </td>
                        <td>
                          <p
                            className="table-user-data-report"
                            style={{
                              color:
                                item.responseStatus === "SUCCESS" ||
                                item.responseStatus === "SETTLED"
                                  ? "green"
                                  : item.responseStatus === "FAILED" ||
                                      item.responseStatus ===
                                        "SETTLEMENT_FAILED"
                                    ? "red"
                                    : item.responseStatus === "PROCESSING" ||
                                        item.responseStatus ===
                                          "SETTLEMENT_PROCESS"
                                      ? "orange"
                                      : "black",
                              fontWeight: "bold",
                            }}
                          >
                            {item.responseStatus === "SETTLEMENT_PROCESS"
                              ? "PROCESSING"
                              : item.responseStatus === "SETTLEMENT_FAILED"
                                ? "FAILED"
                                : item.responseStatus}
                          </p>
                        </td>

                        <td>
                          <button
                            className="view-btn"
                            onClick={() =>
                              viewData(item, setModalData, setOpenModal)
                            }
                          >
                            View
                          </button>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          ) : (
            <div>
              <div className="dummy-out">
                {(role == "super" ||
                  role == "operation" ||
                  role == "trafficManager" ||
                  role == "subSuper") && (
                  <div className="filter-pos">
                    <div className="data-icon">
                      <p className="user-table-head-report">Org Name</p>
                      <FaFilter
                        style={{
                          marginRight: "0.2rem",
                          width: "1rem",
                          height: "1rem",
                          cursor: "pointer",
                        }}
                        onMouseEnter={() => setOrgName(true)}
                        onMouseLeave={() => setOrgName(false)}
                      />
                    </div>
                    {orgName && (
                      <div
                        className="transfer-mode"
                        style={{
                          padding: "4px",
                          minWidth: "200px",
                          width: "max-content",
                          maxWidth: "90vw",
                        }}
                        onMouseEnter={() => setOrgName(true)}
                        onMouseLeave={(e) => {
                          if (e.relatedTarget?.closest?.(".transfer-mode"))
                            return;
                          setOrgName(false);
                        }}
                      >
                        <Select
                          options={[
                            { value: "All", label: "All" },
                            ...(orgSelectOptions?.length
                              ? orgSelectOptions
                              : []),
                          ]}
                          placeholder="Search Org..."
                          isClearable
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          menuPlacement="auto"
                          onChange={(option) => {
                            setSelectedOrgName(option?.value || "All");
                            setOrgName(false);
                          }}
                          styles={{
                            menu: (base) => ({ ...base, zIndex: 9999 }),
                            control: (base) => ({
                              ...base,
                              minHeight: "32px",
                              height: "32px",
                            }),
                            indicatorsContainer: (base) => ({
                              ...base,
                              height: "32px",
                            }),
                          }}
                        />
                      </div>
                    )}
                  </div>
                )}
                {(role == "super" ||
                  role == "operation" ||
                  role == "trafficManager" ||
                  role == "subSuper") && (
                  <div className="filter-pos">
                    <div className="data-icon">
                      <p className="user-table-head-report">Business Name</p>
                      <FaFilter
                        style={{
                          marginRight: "0.2rem",
                          width: "1rem",
                          height: "1rem",
                          cursor: "pointer",
                        }}
                        onMouseEnter={() => setBusinessName(true)}
                        onMouseLeave={() => setBusinessName(false)}
                      />
                    </div>
                    {businessName && (
                      <div
                        className="transfer-mode"
                        style={{ padding: "6px", minWidth: "220px" }}
                        onMouseEnter={() => setBusinessName(true)}
                        onMouseLeave={(e) => {
                          if (e.relatedTarget?.closest?.(".transfer-mode"))
                            return;
                          setBusinessName(false);
                        }}
                      >
                        <Select
                          options={[
                            { value: "All", label: "All" },
                            ...(businessOptions?.length ? businessOptions : []),
                          ]}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          placeholder="Search Business..."
                          isClearable
                          menuPlacement="auto"
                          onChange={(option) => {
                            setSelectedBusinessName(option?.value || "All");
                            setBusinessName(false);
                          }}
                          styles={{
                            menu: (base) => ({ ...base, zIndex: 9999 }),
                            control: (base) => ({
                              ...base,
                              minHeight: "32px",
                              height: "32px",
                            }),

                            /**
                             * Styling for the container of indicators.
                             * This includes the height of the container.
                             */
                            indicatorsContainer: (base) => ({
                              ...base,
                              height: "32px",
                            }),
                          }}
                        />
                      </div>
                    )}
                  </div>
                )}
                {(role == "super" ||
                  role == "operation" ||
                  role == "subSuper") && (
                  <div>
                    <p className="dummy-2">PG Name</p>
                  </div>
                )}
                <div className="dummy-2">Transfer Mode</div>
                <div className="dummy-2">Order Id</div>

                <div className="dummy-2">Txn Type</div>

                {(role == "admin" || role == "mops") && (
                  <div className="dummy-2">Ref ID</div>
                )}
                {(role == "admin" || role == "mops") && (
                  <div className="dummy-2">Transaction Time</div>
                )}
                <div className="dummy-2">Amount</div>
                <div className="dummy-2">Commision</div>
                <div className="dummy-2">
                  {" "}
                  <div className="data-icon filter-pos">
                    <p className="user-table-head-report">Status</p>

                    <FaFilter
                      style={{
                        marginRight: "0.2rem",
                        width: "1rem",
                        height: "1rem",
                        cursor: "pointer",
                      }}
                      onMouseEnter={() => setShowStatus(true)}
                      onMouseLeave={() => setShowStatus(false)}
                    />
                  </div>
                  {showStatus && (
                    <div
                      className="status-mode-1"
                      onMouseEnter={() => setShowStatus(true)}
                      onMouseLeave={() => setShowStatus(false)}
                    >
                      <p onClick={() => setStatus("")}>All</p>
                      <p onClick={() => setStatus("SETTLED")}>Settled</p>
                      <p onClick={() => setStatus("SETTLEMENT_PROCESS")}>
                        Processing
                      </p>
                      <p onClick={() => setStatus("SETTLEMENT_FAILED")}>
                        Failed
                      </p>
                    </div>
                  )}
                </div>
                <div className="dummy-2">Closing Balance</div>
                <div className="dummy-2">Action</div>
              </div>

              <div className="no-data">
                <div className="no-data-2">
                  <p>No Data Found</p>
                </div>
              </div>
            </div>
          )
        ) : (
          <div>
            <div className="dummy-out">
              <div className="dummy-2">Transfer Mode</div>
              <div className="dummy-2">Txn Type</div>
              <div className="dummy-2">Status</div>
              <div className="dummy-2">Transaction Time</div>
              <div className="dummy-2">Ref Id</div>
              <div className="dummy-2">Amount</div>
              <div className="dummy-2">Commision</div>
              <div className="dummy-2">Closing Balance</div>
              <div className="dummy-2">Action</div>
            </div>

            <div className="no-data">
              <div className="no-data-2">
                <p>No Data Found</p>
              </div>
            </div>
          </div>
        )}

        <div>
          <Pagination page={page} setPage={setPage} totalPages={totalPages} />
        </div>
      </div>

      {openModal && modalData && (
        <Modal modalData={modalData} setOpenModal={setOpenModal} />
      )}
    </>
  );
}

export default ReportTable;
